var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcActionShareemail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_action_shareemail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_shareemail",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "//-Base",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.302,4.531 C2.785,4.198 3.369,4 4,4 L20,4 C20.631,4 21.215,4.198 21.698,4.531 L14.252,11.654 C14.252,11.654 14.252,11.654 14.252,11.654 L14.252,11.654 L13.037,12.816 C12.456,13.373 11.544,13.373 10.963,12.816 L2.302,4.531 Z M23,7 C23,6.337 22.777,5.73 22.412,5.233 L15.337,12 L22.412,18.767 C22.777,18.27 23,17.663 23,17 L23,7 Z M14.614,12.692 L13.729,13.539 C13.245,14.002 12.622,14.234 12,14.234 C11.378,14.234 10.756,14.002 10.272,13.539 L9.386,12.692 L2.301,19.469 C2.785,19.802 3.369,20 4,20 L20,20 C20.631,20 21.215,19.802 21.698,19.469 L14.614,12.692 Z M1.588,5.233 C1.223,5.73 1,6.337 1,7 L1,17 C1,17.663 1.223,18.27 1.588,18.767 L8.663,12 L1.588,5.233 Z",
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionShareemail);
export default __webpack_public_path__ + "static/media/ic_action_shareemail.49373669132d32a933aa88aa744ca00c.svg";
export { ForwardRef as ReactComponent };